import Header from "../../components/VibrantSolComponents/Header";
import Footer from "../../components/VibrantSolComponents/Footer";
import productimg from "../../product-01-330x440.jpg";
import productimg1 from "../../product-02-330x440.jpg";
import productimg2 from "../../product-03-330x440.jpg";
import abouimg from "../../why-choose-img-2.jpg";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../components/ui/tabs";
import cards from "../../product-info-2.png";
import React, { useState } from "react";
import { Clock, Eye, Package, Truck } from "lucide-react";

const images = [productimg, productimg1, productimg2, "/video-thumb.jpg"];

function SingleProductDetails() {
  const [selected, setSelected] = useState(0);
  const isVideo = images[selected].endsWith("video-thumb.jpg");
  const [quantity, setQuantity] = useState(1);

  const decrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const increment = () => {
    setQuantity(quantity + 1);
  };
  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2">
            <li>
              <span className="text-gray-400 font-medium">Home</span>
            </li>
            <li>
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Products</span>
            </li>
            <li>
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Products</span>
            </li>
          </ol>
        </nav>

        {/* Responsive grid container */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto py-12 px-4">
          {/* Left: Image Slider */}
          <div className="flex gap-8 w-full">
            <div className="flex flex-col gap-4">
              {images.map((src, idx) => (
                <button
                  key={src}
                  className={`border ${
                    selected === idx ? "border-black" : "border-transparent"
                  } rounded w-20 flex items-center justify-center overflow-hidden bg-white`}
                  onClick={() => setSelected(idx)}
                >
                  {src.endsWith("video-thumb.jpg") ? (
                    <div className="relative w-20 h-20">
                      <img
                        src={src}
                        alt=""
                        className="w-20 h-20 object-cover"
                      />
                      {/* Play icon for video */}
                      <span className="absolute inset-0 flex items-center justify-center">
                        <svg
                          className="w-8 h-8 text-white"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </span>
                    </div>
                  ) : (
                    <img src={src} alt="" className="w-20 object-cover" />
                  )}
                </button>
              ))}
            </div>
            <div className="bg-white flex items-center justify-center w-full">
              {isVideo ? (
                <video
                  src="/video.mp4"
                  controls
                  className="w-full object-contain rounded"
                />
              ) : (
                <img
                  src={images[selected]}
                  alt=""
                  className="w-full object-contain rounded"
                />
              )}
            </div>
          </div>

          {/* Right: Product Details */}
          <div className="w-full flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <span className="text-gray-400 text-lg line-through">$39.00</span>
              <span className="text-2xl font-bold">$29.00</span>
              <span className="bg-green-200 text-green-900 font-semibold rounded px-2 py-1 text-sm">
                20%
              </span>
            </div>
            <h1 className="text-2xl font-semibold mb-1">
              Natural Coconut Cleansing Oil
            </h1>
            <div className="flex items-center gap-2 text-base">
              <span className="font-bold text-black">4.86</span>
              <span className="text-green-600">★★★★★</span>
              <span className="text-green-600">|</span>
              <span className="text-sm text-gray-500">Read 2947 reviews</span>
            </div>
            <p className="mt-2 text-gray-600">
              Niacinamide and Vitamin C are two anti-aging superstars but not
              usually formulated together because of their different pH levels.
            </p>
            <div className="flex flex-col gap-2 mt-1 mb-2">
              <div className="flex items-center gap-1 text-gray-600 text-sm">
                <Eye className="w-4 h-4" />
                <span className="font-medium text-black">17 people</span> are
                viewing this right now
              </div>
              <div className="flex items-center gap-1 text-gray-600 text-sm">
                <Clock className="w-4 h-4" />
                <span className="font-medium text-black">
                  Only 9 left in stock
                </span>
              </div>
            </div>

            <span className="block font-medium">Quantity:</span>
            <div className="flex items-center gap-4 mb-3">
              <div>
                <div
                  className="flex items-center mt-1 border rounded-lg w-max justify-between"
                  style={{ width: "12rem" }}
                >
                  <button
                    className="w-12 h-12 text-xl flex items-center justify-center"
                    onClick={decrement}
                    disabled={quantity === 1}
                  >
                    -
                  </button>
                  <span className="mx-3">{quantity}</span>
                  <button
                    className="w-12 h-12 text-xl flex items-center justify-center"
                    onClick={increment}
                  >
                    +
                  </button>
                </div>
              </div>
              <button className="bg-black text-white text-lg font-semibold px-8 py-3 rounded-lg ml-4 w-full max-w-xs">
                Add To Bag
              </button>
            </div>
            <div className="text-sm text-gray-700 flex items-center gap-2 mt-4">
              <Truck />
              Get it between:{" "}
              <span className="font-semibold ml-1">Feb 3 - Feb 14, 2021</span>
            </div>
            <div className="text-sm text-gray-700 flex items-center gap-2">
              <Package />
              Free Shipping & Returns:{" "}
              <span className="font-semibold ml-1">
                On all orders over $200
              </span>
            </div>
            <div className="bg-gray-50 border p-4 rounded mt-4 flex flex-col items-center">
              <img src={cards} alt="payment methods" className="mb-1" />
              <span className="text-gray-500 text-xs mt-2">
                Guarantee safe &amp; secure checkout
              </span>
            </div>
          </div>
        </div>
        <Tabs
          defaultValue="details"
          className="w-full max-w-7xl mx-auto pt-5 pb-12"
        >
          {/* Tabs Navigation */}
          <TabsList className="!flex justify-center space-x-10 mb-10 bg-transparent">
            <TabsTrigger
              value="details"
              className="px-4 py-2 !text-2xl font-semibold border-0 border-b-4 
               data-[state=active]:border-black data-[state=active]:text-black 
               text-gray-400 transition"
            >
              Product Details
            </TabsTrigger>
            <TabsTrigger
              value="howto"
              className="px-4 py-2 !text-2xl font-semibold border-0 border-b-4 
               data-[state=active]:border-black data-[state=active]:text-black 
               text-gray-400 transition"
            >
              How To Use
            </TabsTrigger>
            <TabsTrigger
              value="ingredients"
              className="px-4 py-2 !text-2xl font-semibold border-0 border-b-4 
               data-[state=active]:border-black data-[state=active]:text-black 
               text-gray-400 transition"
            >
              Ingredients
            </TabsTrigger>
          </TabsList>

          {/* Tab Panel: Product Details */}
          <TabsContent value="details">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
              {/* Left: Product Image */}
              <div>
                <img
                  src={abouimg}
                  alt="Product"
                  className="w-full h-auto rounded"
                />
              </div>
              {/* Right: Product Info */}
              <div>
                <p className="font-bold mb-2">
                  For Normal, Oily, Combination Skin Types
                </p>
                <p className="text-gray-600 mb-3">
                  Complexion-perfecting natural foundation enriched with
                  antioxidant-packed superfruits, vitamins, and other
                  skin-nourishing nutrients. Creamy liquid formula sets with a
                  pristine matte finish for soft, velvety smooth skin.
                </p>
                <p className="text-gray-600 mb-3">
                  Say hello to flawless, long-lasting foundation that comes in 7
                  melt-into-your-skin shades. This lightweight, innovative
                  formula creates a smooth, natural matte finish that won’t
                  settle into lines. It’s the perfect fit for your skin. 1 fl.
                  oz.
                </p>
                <p className="font-semibold mb-2">Benefits</p>
                <ul className="list-disc ml-5 text-gray-600 mb-6 space-y-2">
                  <li>Buildable medium-to-full coverage</li>
                  <li>Weightless, airy feel—no caking!</li>
                  <li>Long-wearing</li>
                  <li>Evens skin tone</li>
                  <li>Available in 07 shades (all exclusive to Makeaholic!)</li>
                </ul>
                {/* Benefit Icons */}
                {/* <div className="flex gap-8 pt-2">
                  <div className="flex flex-col items-center">
                    <img
                      src="/not-tested-on-animals.svg"
                      alt="Not tested on animals"
                      className="h-8 mb-1"
                    />
                    <span className="text-[13px]">
                      NOT TESTED
                      <br />
                      ON ANIMALS
                    </span>
                  </div>
                  <div className="flex flex-col items-center">
                    <img
                      src="/cruelty-free.svg"
                      alt="Cruelty Free"
                      className="h-8 mb-1"
                    />
                    <span className="text-[13px]">CRUELTY FREE</span>
                  </div>
                  <div className="flex flex-col items-center">
                    <img
                      src="/period-after-opening.svg"
                      alt="Period After Opening"
                      className="h-8 mb-1"
                    />
                    <span className="text-[13px] text-center">
                      PERIOD AFTER
                      <br />
                      OPENING
                    </span>
                  </div>
                  <div className="flex flex-col items-center">
                    <img
                      src="/recycle.svg"
                      alt="Recycle"
                      className="h-8 mb-1"
                    />
                    <span className="text-[13px]">RECYCLE</span>
                  </div>
                </div> */}
              </div>
            </div>
          </TabsContent>

          {/* Tab Panel: How to Use */}
          <TabsContent value="howto">
            <h2 className="font-bold mb-3">How to Use</h2>
            <div class="pb-3">
              <p class="fw-semibold text-body-emphasis mb-2 pb-4">
                Follow these safety guidelines when using cosmetics products of
                any type:
              </p>
              <ul className="list-disc ml-5 text-gray-600 space-y-2">
                <li class="mb-3">
                  Read the label. Follow all directions and heed all warnings.
                </li>
                <li class="mb-3">
                  Wash your hands before you use the product.
                </li>
                <li class="mb-3">Do not share makeup.</li>
                <li class="mb-3">
                  Keep the containers clean and tightly closed when not in use,
                  and protect them from temperature extremes.
                </li>
                <li class="mb-3">
                  Throw away cosmetics if there are changes in color or smell.
                </li>
                <li>
                  Use aerosols or sprays cans in well-ventilated areas. Do not
                  use them while you are smoking or near an open flame. It could
                  start a fire.
                </li>
              </ul>
            </div>
          </TabsContent>

          {/* Tab Panel: Ingredients */}
          <TabsContent value="ingredients">
            <div>
              {/* Table-like rows */}
              <div className="grid grid-cols-2 gap-y-4 gap-x-2 text-sm mb-8">
                <span className="font-medium">CAS</span>
                <span className="text-right text-gray-700">
                  92128-82-0, 9057-02-7
                </span>

                <span className="font-medium">INCI</span>
                <span className="text-right text-gray-700">
                  Nannochloropsis Oculata (micro algae) extract, pullulan
                </span>

                <span className="font-medium">Composition</span>
                <span className="text-right text-gray-700">
                  Nannochloropsis Oculata (micro algae) extract, pullulan,
                  water, ethanol
                </span>

                <span className="font-medium">Appearance</span>
                <span className="text-right text-gray-700">
                  Yellow to amber, viscous liquid
                </span>

                <span className="font-medium">Solubility</span>
                <span className="text-right text-gray-700">
                  Soluble in water &amp; ethanol
                </span>

                <span className="font-medium">Storage</span>
                <span className="text-right text-gray-700">
                  Store refrigerated (4-8°C / 39-46°F)
                </span>
              </div>
              {/* Description */}
              <p className="text-gray-400 text-sm">
                Perfect for Equestrian homes or every horse lover. Designer
                premium signature aluminum alloy all Arthur Court is compliance
                with FDA regulations. Aluminum Serveware can be chilled in the
                freezer or refrigerator and warmed in the oven to 350. Wash by
                hand with mild dish soap and dry immediately – do not put in the
                dishwasher. Comes in Gift Box perfect for Equestrian home or
                Horse lover in your life.
              </p>
            </div>
          </TabsContent>
        </Tabs>
      </div>
      <Footer />
    </>
  );
}

export default SingleProductDetails;
